import { render, staticRenderFns } from "./adminBar.vue?vue&type=template&id=f2067aba&"
import script from "./adminBar.vue?vue&type=script&lang=js&"
export * from "./adminBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports